export const parseMessageContent = (msg) => {
  let content = '';
  let data = null;
  
  if (typeof msg.content === 'string') {
    content = msg.content;
  } else if (msg.content?.txt) {
    content = msg.content.txt;
  } else if (msg.content) {
    content = JSON.stringify(msg.content);
    try {
      data = typeof msg.content === 'object' ? msg.content : JSON.parse(msg.content);
    } catch (e) {
      data = msg.content;
    }
  }
  
  return { content, data };
};

export const getComparableContent = (msg) => {
  if (!msg) return '';
  const { content, data } = parseMessageContent(msg);
  const contentStr = (content || '').toString().trim();
  const hasImage = (data?.ent || msg?.data?.ent || msg?.content?.ent)?.some(
    (e) => e.tp === 'IM' || e.tp === 'EX'
  );
  const isImageOnly = hasImage && (!contentStr || contentStr.startsWith('{') || contentStr === 'No Image');
  if (isImageOnly) return 'No Image';
  return contentStr;
};

export const getMessageTimestamp = (msg) => {
  const msgTimestamp = msg.timestamp || msg.ts || msg.created || Date.now();
  return typeof msgTimestamp === 'number' 
    ? msgTimestamp 
    : (new Date(msgTimestamp).getTime() || Date.now());
};

export const sortMessagesBySeq = (messages) => {
  if (!messages || messages.length === 0) return messages;
  
  return [...messages].sort((a, b) => {
    const aIsOptimistic = a.seq?.toString().startsWith('temp_');
    const bIsOptimistic = b.seq?.toString().startsWith('temp_');
    
    if (aIsOptimistic && bIsOptimistic) {
      const tsA = typeof a.timestamp === 'number' 
        ? a.timestamp 
        : (a.ts ? new Date(a.ts).getTime() : (new Date(a.timestamp || 0).getTime() || 0));
      const tsB = typeof b.timestamp === 'number' 
        ? b.timestamp 
        : (b.ts ? new Date(b.ts).getTime() : (new Date(b.timestamp || 0).getTime() || 0));
      return tsA - tsB;
    }
    
    if (aIsOptimistic) {
      if (a.realSeq) {
        const seqB = typeof b.seq === 'number' ? b.seq : (parseInt(b.seq) || 0);
        const realSeqA = typeof a.realSeq === 'number' ? a.realSeq : (parseInt(a.realSeq) || 0);
        if (realSeqA !== seqB) {
          return realSeqA - seqB;
        }
      }
      const tsA = typeof a.timestamp === 'number' 
        ? a.timestamp 
        : (a.ts ? new Date(a.ts).getTime() : (new Date(a.timestamp || 0).getTime() || 0));
      const tsB = typeof b.timestamp === 'number' 
        ? b.timestamp 
        : (b.ts ? new Date(b.ts).getTime() : (new Date(b.timestamp || 0).getTime() || 0));
      return tsA - tsB;
    }
    
    if (bIsOptimistic) {
      if (b.realSeq) {
        const seqA = typeof a.seq === 'number' ? a.seq : (parseInt(a.seq) || 0);
        const realSeqB = typeof b.realSeq === 'number' ? b.realSeq : (parseInt(b.realSeq) || 0);
        if (seqA !== realSeqB) {
          return seqA - realSeqB;
        }
      }
      const tsA = typeof a.timestamp === 'number' 
        ? a.timestamp 
        : (a.ts ? new Date(a.ts).getTime() : (new Date(a.timestamp || 0).getTime() || 0));
      const tsB = typeof b.timestamp === 'number' 
        ? b.timestamp 
        : (b.ts ? new Date(b.ts).getTime() : (new Date(b.timestamp || 0).getTime() || 0));
      return tsA - tsB;
    }
    
    const seqA = typeof a.seq === 'number' ? a.seq : (parseInt(a.seq) || 0);
    const seqB = typeof b.seq === 'number' ? b.seq : (parseInt(b.seq) || 0);
    
    if (seqA !== seqB) {
      return seqA - seqB;
    }
    
    const tsA = typeof a.timestamp === 'number' 
      ? a.timestamp 
      : (a.ts ? new Date(a.ts).getTime() : (new Date(a.timestamp || 0).getTime() || 0));
    const tsB = typeof b.timestamp === 'number' 
      ? b.timestamp 
      : (b.ts ? new Date(b.ts).getTime() : (new Date(b.timestamp || 0).getTime() || 0));
    
    return tsA - tsB;
  });
};

export const sortMessagesWithOptimistic = (messages) => {
  if (!messages || messages.length === 0) return messages;
  
  return [...messages].sort((a, b) => {
    const aIsOptimistic = a.seq?.toString().startsWith('temp_');
    const bIsOptimistic = b.seq?.toString().startsWith('temp_');
    
    if (aIsOptimistic && bIsOptimistic) {
      const tsA = typeof a.timestamp === 'number' 
        ? a.timestamp 
        : (a.ts ? new Date(a.ts).getTime() : 0);
      const tsB = typeof b.timestamp === 'number' 
        ? b.timestamp 
        : (b.ts ? new Date(b.ts).getTime() : 0);
      return tsA - tsB;
    }
    
    if (aIsOptimistic) return 1;
    if (bIsOptimistic) return -1;
    
    let seqA = 0;
    let seqB = 0;
    
    if (typeof a.seq === 'number') {
      seqA = a.seq;
    } else if (a.seq) {
      const parsed = parseInt(a.seq);
      seqA = isNaN(parsed) ? 0 : parsed;
    }
    
    if (typeof b.seq === 'number') {
      seqB = b.seq;
    } else if (b.seq) {
      const parsed = parseInt(b.seq);
      seqB = isNaN(parsed) ? 0 : parsed;
    }
    
    if (seqA !== seqB) {
      return seqA - seqB;
    }
    
    const tsA = typeof a.timestamp === 'number' 
      ? a.timestamp 
      : (a.ts ? new Date(a.ts).getTime() : (a.timestamp ? new Date(a.timestamp).getTime() : 0));
    const tsB = typeof b.timestamp === 'number' 
      ? b.timestamp 
      : (b.ts ? new Date(b.ts).getTime() : (b.timestamp ? new Date(b.timestamp).getTime() : 0));
    
    return tsA - tsB;
  });
};

export const extractSeqFromResponse = (sentMessage) => {
  return sentMessage?.params?.seq || sentMessage?.seq || null;
};

export const formatMessageForChats = (msg, currentUserId) => {
  const { content, data } = parseMessageContent(msg);
  const msgTimestamp = getMessageTimestamp(msg);
  const isMe = msg.from === currentUserId;
  
  return {
    sender: isMe ? "me" : "other",
    message: content,
    time: new Date(msgTimestamp).toLocaleTimeString(),
    timestamp: msgTimestamp,
    data: data,
    customType: msg.head?.customType || "1",
    seq: msg.seq
  };
};

export const formatMessageForDashboard = (msg, topicName) => {
  const { content } = parseMessageContent(msg);
  const msgTimestamp = getMessageTimestamp(msg);
  
  let seq = msg.seq;
  if (seq === undefined || seq === null) {
    seq = `temp_${msgTimestamp}`;
  }
  
  const msgContent = msg.content || {};
  const hasDraftyContent = msgContent.ent && Array.isArray(msgContent.ent);
  
  const isOptimistic = seq && seq.toString().startsWith('temp_');
  
  return {
    seq: seq,
    from: msg.from,
    content: content,
    data: hasDraftyContent ? msgContent : null,
    ts: new Date(msgTimestamp).toISOString(),
    timestamp: msgTimestamp,
    topic: msg.topic || topicName,
    ...(isOptimistic ? { isOptimistic: true } : {})
  };
};

export const shouldSkipMessage = (msg, messageSeqSet) => {
  if (!msg || !msg.seq) return true;
  if (msg.noecho === true) return true;
  if (messageSeqSet.has(msg.seq)) return true;
  return false;
};

export const mergeAndSortMessages = (existingMessages, newMessages, useOptimistic = false) => {
  const existingMap = new Map(existingMessages.map(m => [m.seq, m]));
  
  newMessages.forEach(msg => {
    if (!existingMap.has(msg.seq)) {
      existingMap.set(msg.seq, msg);
    }
  });
  
  const merged = Array.from(existingMap.values());
  return useOptimistic 
    ? sortMessagesWithOptimistic(merged)
    : sortMessagesBySeq(merged);
};

export const getDateSeparatorLabel = (timestamp) => {
  if (!timestamp) return '';
  
  const msgDate = new Date(timestamp);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  
  const msgDateOnly = new Date(msgDate.getFullYear(), msgDate.getMonth(), msgDate.getDate());
  const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const yesterdayOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());
  
  if (msgDateOnly.getTime() === todayOnly.getTime()) {
    return 'TODAY';
  } else if (msgDateOnly.getTime() === yesterdayOnly.getTime()) {
    return 'YESTERDAY';
  } else {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return msgDate.toLocaleDateString('en-US', options);
  }
};

export const getDateKey = (timestamp) => {
  if (!timestamp) return '';
  
  const msgDate = new Date(timestamp);
  const year = msgDate.getFullYear();
  const month = String(msgDate.getMonth() + 1).padStart(2, '0');
  const day = String(msgDate.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};

